// extracted by mini-css-extract-plugin
export var completionBody = "_dt-2";
export var completionCard = "_dt-0";
export var completionFooter = "_dt-3";
export var completionTitle = "_dt-1";